module.exports = __webpack_public_path__ + "img/23-Prince-frog.4d7c2b9c.jpg";